(function (window) {
    window.__env = window.__env || {};

    window.__env.apiUrl = '#{apiUrl}#';
    window.__env.fmsAdminAppBaseUrl = '#{fmsAdminAppBaseUrl}#';

    window.__env.AzureADSettings = {
        endpoints: {},
        instance: 'https://login.microsoftonline.com/',
        tenant: '#{tenant}#',
        clientId: '#{clientId}#',
        redirectUri: '#{redirectUri}#',
        anonymousEndpoints: []
    };

    window.__env.AzureADSettings.endpoints[window.__env.apiUrl] = '#{fmsApiResourceId}#';

    window.__env.AzureADSettings.anonymousEndpoints.push(__env.apiUrl + "/HealthCheck/Check");
    window.__env.AzureADSettings.anonymousEndpoints.push(__env.apiUrl + "/Home/GetPublicConfigData");
    window.__env.AzureADSettings.anonymousEndpoints.push(__env.apiUrl + "/Home/GetApplicationLastUpdateDate");
    window.__env.AzureADSettings.anonymousEndpoints.push(__env.apiUrl + "/Feedback/PublicSubmitFeedback");
    window.__env.AzureADSettings.anonymousEndpoints.push(__env.apiUrl + "/Feedback/PublicSaveIncidentForDocumentUpload");
    window.__env.AzureADSettings.anonymousEndpoints.push(__env.apiUrl + "/Feedback/PublicSaveDocument");
    window.__env.AzureADSettings.anonymousEndpoints.push(__env.apiUrl + "/Feedback/PublicDeleteDocument");
    window.__env.AzureADSettings.anonymousEndpoints.push(__env.apiUrl + "/Feedback/PublicGetDocument");
    window.__env.AzureADSettings.anonymousEndpoints.push(__env.apiUrl + "/pdf/GetFeedbackPdf");
    window.__env.AzureADSettings.anonymousEndpoints.push(__env.apiUrl + "/pdf/GetComplaintsUnRegisteredPdf");
    window.__env.AzureADSettings.anonymousEndpoints.push(__env.apiUrl + "/DocumentTemplate/GetDocumentTemplateFile");
    window.__env.AzureADSettings.anonymousEndpoints.push("images/");

    window.__env.GooglePlacesAPIKey = 'AIzaSyALZxz3Ub7yycbQ0XLpztHIAlsh-M0WZj0';
    window.__env.GoogleMapsClientId = 'gme-dohs';
    window.__env.GoogleRecaptchaResponseKey = 'g-recaptcha-response';

    window.__env.GoogleRecaptchaSecret = '6LcJoIsUAAAAAEamGCzcQ0gAS1tJ3NPIWFMhwW6e';
    window.__env.GoogleRecaptchaKey = '6LcJoIsUAAAAAKxG1pTR3X74FRK3Xlnb602dxCn1';

    window.__env.GoogleRecaptchaTestSecret = '6LeIxAcTAAAAAGG-vFI1TnRWxMZNFuojJ4WifJWe';
    window.__env.GoogleRecaptchaTestKey = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
    window.__env.IsTestRecaptcha = false;


    window.__env.enableDebug = true;
}(this));